import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import { AuthProvider } from './context/AuthContext';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import Booking from './pages/Booking';
import MiniChart from './pages/MiniChart';
import Login from './pages/Login';
import Register from './pages/Register';
import VerifyEmail from './pages/VerifyEmail';
import Dashboard from './pages/Dashboard';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import BusinessCareer from './pages/BusinessCareer';
import HealthEnergy from './pages/HealthEnergy';
import MoneyFinances from './pages/MoneyFinances';
import FamilyRelationships from './pages/FamilyRelationships';
import GrowingStarsPage from './pages/GrowingStars';
import TermsCancellation from './pages/TermsCancellation';
import TermsRefund from './pages/TermsRefund';
import TermsPrivacy from './pages/TermsPrivacy';
import ContactPage from './pages/ContactPage';
import FAQ from './pages/FAQ';
import FounderMessage from './pages/FounderMessage';
import Blog from './pages/Blog';

function App() {
  return (
    <AuthProvider>
      <Router>
        <ScrollToTop />
        <div className="App">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/booking" element={<Booking />} />
            <Route path="/mini-chart" element={<MiniChart />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/business-career" element={<BusinessCareer />} />
            <Route path="/health-energy" element={<HealthEnergy />} />
            <Route path="/money-finances" element={<MoneyFinances />} />
            <Route path="/family-relationships" element={<FamilyRelationships />} />
            <Route path="/growing-stars" element={<GrowingStarsPage />} />
            <Route path="/terms/cancellation" element={<TermsCancellation />} />
            <Route path="/terms/refund" element={<TermsRefund />} />
            <Route path="/terms/privacy" element={<TermsPrivacy />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/founder-message" element={<FounderMessage />} />
            <Route path="/blog" element={<Blog />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;